import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-task-icon",
  "use": "icon-task-icon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-task-icon\">\n\t<path d=\"M16 1H8v4h8z\" />\n\t<path d=\"M3 3h3v4h12V3h3v8.674A7 7 0 0 0 13.101 23H3z\" />\n\t<path d=\"M12.5 18a5.5 5.5 0 1 1 11 0a5.5 5.5 0 0 1-11 0m7.914 1L19 17.586v-1.834h-2v2.662l2 2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol